const safeObject = value =>
  value && typeof value === 'object' && !Array.isArray(value) ? value : {};
const safeArray = value => (Array.isArray(value) ? value : []);
const normalizeString = value => (typeof value === 'string' ? value.trim() : '');

const userPrivateData = currentUser =>
  currentUser?.attributes?.profile?.privateData ||
  currentUser?.attributes?.privateData ||
  currentUser?.privateData ||
  {};

const normalizeEmailState = value => {
  const source = safeObject(value);
  return {
    eventId: normalizeString(source.eventId) || null,
    status: normalizeString(source.status).toLowerCase() || null,
    sentAt: source.sentAt || null,
    skippedAt: source.skippedAt || null,
    failedAt: source.failedAt || null,
    reason: normalizeString(source.reason) || null,
    messageId: normalizeString(source.messageId) || null,
  };
};

const normalizeNotificationEvent = value => {
  const source = safeObject(value);
  return {
    eventId: normalizeString(source.eventId) || null,
    type: normalizeString(source.type) || null,
    transition: normalizeString(source.transition) || null,
    transactionId: normalizeString(source.transactionId) || null,
    listingId: normalizeString(source.listingId) || null,
    listingTitle: normalizeString(source.listingTitle) || '',
    actorRole: normalizeString(source.actorRole) || null,
    recipientRole: normalizeString(source.recipientRole) || null,
    createdAt: source.createdAt || null,
    quantity:
      Number.isInteger(source.quantity) && source.quantity > 0 ? source.quantity : null,
    offerPrice:
      Number.isInteger(source.offerPrice) && source.offerPrice > 0 ? source.offerPrice : null,
    currency: normalizeString(source.currency) || null,
    email: normalizeEmailState(source.email),
  };
};

export const getOfferNotifications = currentUser => {
  const source = safeObject(userPrivateData(currentUser)?.offerNotifications);
  const events = safeArray(source.events)
    .map(normalizeNotificationEvent)
    .filter(event => event.eventId);
  const latestEventId = normalizeString(source.latestEventId) || events.at(-1)?.eventId || null;

  return {
    latestEventId,
    events,
  };
};

export const getLatestOfferNotification = currentUser => {
  const notifications = getOfferNotifications(currentUser);
  if (!notifications.latestEventId) {
    return null;
  }

  return (
    notifications.events.find(event => event.eventId === notifications.latestEventId) ||
    notifications.events.at(-1) ||
    null
  );
};

export const getLatestOfferNotificationEventId = currentUser => {
  return getLatestOfferNotification(currentUser)?.eventId || null;
};
